import React from "react"
import { useSelector } from "react-redux"
import { FaMapMarkerAlt } from "react-icons/fa"
import { useTranslation } from "react-i18next"

import { Tooltip } from "components"
import classes from "./OhEditAddressInput.module.scss"

const OhEditAddressInput = props => {
  const {
    type,
    value,
    deliveryService,
    onMapMarkerIconClick
  } = props

  const [t] = useTranslation()

  const systemIsActivated =
    useSelector(state => state.systemSettings.systemIsActivated)

  const showMapMarker =
    type === "address" &&
    deliveryService === "internal"

  return (
    <div className={classes["row"]}>
      <span className={classes["value"]}>
        {t("آدرس")}: <b>{systemIsActivated ? value : "************"}</b>
      </span>

      <div className={classes["row-icons"]}>
        {
          showMapMarker &&
          <Tooltip title={t("مشاهده_آدرس_در_نقشه")}>
            <FaMapMarkerAlt
              onClick={onMapMarkerIconClick}
              className={classes["map"]}
            />
          </Tooltip>
        }
      </div>
    </div>
  )
}

export default OhEditAddressInput